import { render, staticRenderFns } from "./BrandConnect.vue?vue&type=template&id=4d9ed5c8"
import script from "./BrandConnect.vue?vue&type=script&lang=js"
export * from "./BrandConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports